import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    ExportNoticeData,
    ExportNoticeDialogComponent,
    ExportNoticeResult,
} from 'app/modules/shared/containers/export-notice-dialog/export-notice-dialog.component';
import { map, Observable } from 'rxjs';

/**
 * Asks the user to confirm an export of personal data and tells them that they are responsible for the
 * exported file (BSI TR-03161-2 O.Data_1, O.Data_2). Every place that lets personal data leave the app
 * as a file calls {@link confirm} first.
 */
@Injectable({ providedIn: 'root' })
export class ExportNoticeService {
    private _dialog = inject(MatDialog);

    /**
     * Emits the user's choice once the dialog is closed: the result when the user confirms
     * (with a password if one was entered), `null` when the user cancels.
     */
    confirm(options: ExportNoticeData = {}): Observable<ExportNoticeResult | null> {
        return this._dialog
            .open<ExportNoticeDialogComponent, ExportNoticeData, ExportNoticeResult | null>(
                ExportNoticeDialogComponent,
                { width: '520px', maxWidth: '95vw', data: options, autoFocus: false },
            )
            .afterClosed()
            .pipe(map((result) => result ?? null));
    }
}
